import React from 'react';
import PropTypes from 'prop-types';
import Tooltip from '@material-ui/core/Tooltip';
import { InfoOutlined as InfoIcon } from '@material-ui/icons';

const ToolTippedInfoIcon = ({ classes, children, placement, size }) => {
  return (
    <Tooltip title={children} placement={placement} classes={classes}>
      <div>
        <InfoIcon style={{ width: size, height: size }} />
      </div>
    </Tooltip>
  );
};

ToolTippedInfoIcon.displayName = 'ToolTippedInfoIcon';
ToolTippedInfoIcon.propTypes = {
  classes: PropTypes.shape({
    tooltip: PropTypes.string,
    popper: PropTypes.string,
    popperInteractive: PropTypes.string,
    touch: PropTypes.string,
    tooltipPlacementLeft: PropTypes.string,
    tooltipPlacementRight: PropTypes.string,
    tooltipPlacementTop: PropTypes.string,
    tooltipPlacementBottom: PropTypes.string,
  }),
  children: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.node,
  ]).isRequired,
  placement: PropTypes.string,
  size: PropTypes.number,
};

ToolTippedInfoIcon.defaultProps = {
  placement: 'top',
  size: 18,
  classes: null,
};

export default ToolTippedInfoIcon;
